const CALCULATOR_BUTTONS = [
  ['C', '<', '@', '+'],
  ['7', '8', '9', '*'],
  ['4', '5', '6', '-'],
  ['1', '2', '3', '/'],
  ['0', '.', '=']
];

// extra rows shown above CALCULATOR_BUTTONS when the org has scientific mode enabled - a clean
// 3x4 grid (12 tokens). sin/cos/tan/log/ln/sqrt/^/pi/e/paren insert a token into the expression
// for the student to keep building on (evaluated by mathjs at '='); sq and inv operate on the
// whole current expression immediately, the same way the existing square-root extra button
// already does. 'paren' is a single smart bracket key (like a phone calculator) rather than
// separate '(' and ')' buttons - see CALCULATOR_SCIENTIFIC_PAREN_INSERT in calculator.jsx.
const CALCULATOR_SCIENTIFIC_BUTTONS = [
  ['sin', 'cos', 'tan', 'sqrt'],
  ['log', 'ln', '^', 'sq'],
  ['pi', 'e', 'inv', 'paren']
];

// button value -> text inserted into the expression (mathjs-native syntax; e.g. 'log' base 10
// is 'log10(' since mathjs's bare log() is natural log, matched to our 'ln' button). 'paren'
// isn't here - which bracket it inserts depends on the expression typed so far, so it's
// resolved dynamically in calculator.jsx instead of via this static lookup.
const CALCULATOR_SCIENTIFIC_INSERT_TOKENS = {
  sin: 'sin(',
  cos: 'cos(',
  tan: 'tan(',
  sqrt: 'sqrt(',
  log: 'log10(',
  ln: 'log(',
  '^': '^',
  pi: 'pi',
  e: 'e'
};

// button values that evaluate the current expression immediately (like the '}' square-root
// extra button) rather than inserting a token to keep typing around
const CALCULATOR_SCIENTIFIC_IMMEDIATE_BUTTONS = ['sq', 'inv'];

// tokens that start a brand new expression rather than continuing the previous one - pressed
// right after '=', these clear the display first instead of appending to the old answer (the
// same way a fresh digit already does). '^' is deliberately excluded: chaining an operator (or
// power) off the previous answer, e.g. "5" "=" "^2", is the expected behaviour, same as
// pressing '+' after '=' already continues from the last answer. 'paren' resets to an opening
// bracket, since a freshly-cleared expression has no unclosed '(' to match.
const CALCULATOR_SCIENTIFIC_RESET_TOKENS = ['sin', 'cos', 'tan', 'log', 'ln', 'sqrt', 'pi', 'e', 'paren'];

const OPERANDS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];

const OPERATORS = ['+', '-', '/', '*'];

const CALCULATOR_EVALUATION = {
  scientific: 0,
  leftToRight: 1
}

const CALCULATOR_PARTS={operand:1, operator:2}

export {
  CALCULATOR_BUTTONS,
  CALCULATOR_SCIENTIFIC_BUTTONS,
  CALCULATOR_SCIENTIFIC_INSERT_TOKENS,
  CALCULATOR_SCIENTIFIC_IMMEDIATE_BUTTONS,
  CALCULATOR_SCIENTIFIC_RESET_TOKENS,
  CALCULATOR_EVALUATION,
  OPERANDS,
  OPERATORS,
  CALCULATOR_PARTS
};
